/* eslint-disable react-func/max-lines-per-function */
import { useCallback } from 'react';
import { Directory, Encoding, Filesystem } from '@capacitor/filesystem';

const STORAGE_INFO = {
  path: 'massagerobot/DONOT_DELETE_PLEASE.txt',
  directory: Directory.Documents,
  encoding: Encoding.UTF8,
};

const useAndroidId = () => {
  // 从本地文件获取存储的androidId
  const getAndroidId: () => Promise<string> = useCallback(() => {
    return new Promise((resolve, reject) => {
      // 检查是否有读取/写入权限
      Filesystem.checkPermissions()
        .then(status => {
          if (status.publicStorage === 'granted') {
            Filesystem.readFile(STORAGE_INFO)
              .then(info => {
                resolve(info.data);
              })
              .catch(e => {
                reject(e);
              });
          }
          // 没有读取权限则请求权限
          if (['prompt-with-rationale', 'prompt'].includes(status.publicStorage)) {
            Filesystem.requestPermissions()
              .then(result => {
                if (result.publicStorage === 'granted') {
                  Filesystem.readFile(STORAGE_INFO)
                    .then(info => {
                      resolve(info.data);
                    })
                    .catch(e => {
                      reject(e);
                    });
                } else {
                  reject('no permission');
                }
              })
              .catch(e => reject(e));
          }
        })
        .catch(e => {
          reject(e);
        });
    });
  }, []);

  const writeFile = useCallback((data: string) => {
    return new Promise((resolve, reject) => {
      // 判断是否有当前文件
      Filesystem.stat({
        path: STORAGE_INFO.path,
        directory: STORAGE_INFO.directory,
      })
        .then((e) => {
          setTimeout(() => {
            console.log('已经有文件，忽略写入操作',e);
          }, 2000);
          resolve('');
        })
        .catch(() => {
          // 判断是否有当前文件夹
          Filesystem.stat({
            path: 'massagerobot',
            directory: STORAGE_INFO.directory,
          })
            .then(statInfo => {
              if (statInfo.type === 'directory') {
                Filesystem.writeFile({
                  ...STORAGE_INFO,
                  data,
                })
                  .then(info => {
                    resolve(info);
                  })
                  .catch(e => {
                    reject(e);
                  });
              } else {
                reject('no directory');
              }
            })
            // 没有文件夹则创建
            .catch(() => {
              Filesystem.mkdir({
                path: 'massagerobot',
                directory: STORAGE_INFO.directory,
              })
                .then(() => {
                  // 文件夹创建成功,写入文件
                  Filesystem.writeFile({
                    ...STORAGE_INFO,
                    data,
                  })
                    .then(info => {
                      resolve(info);
                    })
                    .catch(e => {
                      reject(e);
                    });
                })
                .catch(e => {
                  console.log('mkdir error', e);
                  reject(e);
                });
            });
        });
    });
  }, []);

  /** 保存android到本地文件 */
  const storeAndroidId2File = useCallback(
    (androidId: string) => {
      if (typeof androidId !== 'string') {
        console.error('androidId must be typeof string');
        return;
      }

      return new Promise((resolve, reject) => {
        // 检查是否有读取/写入权限
        Filesystem.checkPermissions()
          .then(status => {
            setTimeout(() => {
              console.log('permission:',status)
            }, 1500);
            if (status.publicStorage === 'granted') {
              writeFile(androidId)
                .then(info => {
                  resolve(info);
                })
                .catch(e => {
                  reject(e);
                });
            }
            // 没有读取权限则请求权限
            if (['prompt-with-rationale', 'prompt'].includes(status.publicStorage)) {
              Filesystem.requestPermissions().then(result => {
                if (result.publicStorage === 'granted') {
                  writeFile(androidId)
                    .then(info => {
                      resolve(info);
                    })
                    .catch(e => {
                      reject(e);
                    });
                } else {
                  reject('no permission');
                }
              });
            }
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    [writeFile]
  );

  return {
    getAndroidId,
    storeAndroidId2File,
  };
};

export default useAndroidId;
